/** Match the supplier's six-decimal cost mirror used by catalog pricing. */
export function supplierStockCost(supplier: { cost: number; unitsPerPurchaseUnit?: number }) {
  return Number((supplier.cost / (supplier.unitsPerPurchaseUnit ?? 1)).toFixed(6));
}
